import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _locationContacts = [];

let LocationContactStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    
    getAll: function() {
         return _locationContacts.filter(function(e) { return e !== undefined; });
    },
    getByLocation: function(id) {
        return _locationContacts.filter(function(e) { return e !== undefined && e.locationId == id; });
    },
    add: function(entity) {
        if (!!entity.id && !!entity.locationId) {
            let index = _locationContacts.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.locationId == entity.locationId; });
            if (0 <= index) {
                _locationContacts[index] = entity;
            } else {
                _locationContacts.push(entity);
            }
        }
    },
    remove: function(id, locationId) {
        let index = _locationContacts.findIndex(function(e) { return e !== undefined && e.id == id && e.locationId == locationId; });
        if (0 <= index) {
            delete _locationContacts[index];
        }
    }

});

LocationContactStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.LOCATION_CONTACT_LIST:
            action.data.forEach(LocationContactStore.add);
            LocationContactStore.emitChange();
            break;

        case ActionTypes.LOCATION_CONTACT_ADD:
            LocationContactStore.add(action.data);
            LocationContactStore.emitChange();
            break;

        case ActionTypes.LOCATION_CONTACT_ADD_ERROR:
            LocationContactStore.emitChange();
            break;

        default:
            break;

    }

});

export default LocationContactStore;
